<template>
  <div class="role-page full-height">
      <table-con  :canReturn='canReturn'>
        <!-- <div slot="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'buddleOrder' }">同捆订单列表</el-breadcrumb-item>
            <el-breadcrumb-item>同捆列表详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <div slot="editBreadcrumb">
          <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
        </div>
        <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('orderList.orderList2')}}:</div>
            <div class="flex1">
              <el-input
                :placeholder="$t('orderList.orderList3')"
                clearable
                v-model="queryInfo.orderId"
                size = "small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
           <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('orderList.orderList5')}}:</div>
            <div class="flex1">
              <el-input
                :placeholder="$t('orderList.orderList3')"
                clearable
                v-model="queryInfo.trackingNumberCn"
                size = "small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('orderList.orderList46')}}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.orderStatus" :placeholder="$t('goods.goods21')" size="small" clearable>
                <el-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('BuddleOrderDetail.BuddleOrderDetail1')}}:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('BuddleOrderDetail.BuddleOrderDetail1')}}:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('BuddleOrderDetail.BuddleOrderDetail3')}}:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title1">{{$t('BuddleOrderDetail.BuddleOrderDetail4')}}:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('query')}}</el-button>
            </div>
          </el-col>
        </el-row>
        <div class="bill_top">
                <span class="tk-title">{{$t('BuddleOrderDetail.BuddleOrderDetail10')}}：<i>{{tkPackageInfo.userName}}</i></span>
                <span class="tk-title">{{$t('BuddleOrder.BuddleOrder15')}}：<i>{{tkPackageInfo.tongkunNo}}</i></span>
                <span class="tk-title">{{$t('OrderDetail.OrderDetail5')}}：<i>{{tkPackageInfo.cartonSize}}</i></span>
                <span class="tk-title">{{$t('OrderDetail.OrderDetail13')}}：<i>{{tkPackageInfo.realWeight}}</i></span>
                <span class="tk-title">{{$t('OrderDetail.OrderDetail9')}}：<i>{{tkPackageInfo.throwWeight}}</i></span>
                <span class="tk-title">{{$t('OrderDetail.OrderDetail6')}}：<i>{{tkPackageInfo.oppType}}</i></span>
                <span class="tk-title">{{$t('OrderDetail.OrderDetail10')}}：<i>{{tkPackageInfo.oppCount}}</i></span>
              </div>
        </div>
        <div slot="table" class="full-height display-col" style="padding:10px">
           <el-table
            :data="recordList"
             border
            style="width: 100%"
            height="550"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
           >
            <el-table-column type="index" align="center"  :label="$t('wzbg.wz6')" width="110"></el-table-column>
            <el-table-column :label="$t('OrderBill.OrderBill15')" align="center" width="80">
              <template v-slot="scope">
                <div class="btn-row">
                  <el-button
                    class="list-btn btn-blue"
                    @click="toOrderDetail(scope.row)"
                    >
                  {{$t('detail')}}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="id" align="center"  :label="$t('orderList.orderList2')" width="105"></el-table-column>
            <el-table-column prop="orderStatus" align="center" :label="$t('orderList.orderList46')" width="120">
              <template v-slot="scope">
                {{orderStatusShow(scope.row.orderStatus)}}
              </template>
            </el-table-column>
            <el-table-column prop="trackingNumberJpn" :label="$t('orderList.orderList4')" width="110"></el-table-column>
            <el-table-column :label="$t('feedback.feedback9')" align="center" width="125">
              <template slot-scope="scope">
                   <img v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt="" class="list-image">
                   <img v-else src="../../../assets/images/default.png" alt="" class="list-image">
              </template>
            </el-table-column>
            <!-- <el-table-column prop="pictureUrl" label="图片"></el-table-column> -->
            <el-table-column prop="createTime" align="center" :index="indexMethod"  sortable :label="$t('BuddleOrderDetail.BuddleOrderDetail5')" min-width="100">
              <template v-slot="scope">
                {{scope.row.createTime | dateFormatToDay}}
              </template>
            </el-table-column>
            <el-table-column prop="receiveTime" align="center" :index="indexMethod"  sortable :label="$t('BuddleOrderDetail.BuddleOrderDetail6')" min-width="100">
              <template v-slot="scope">
                {{scope.row.receiveTime | dateFormatToDay}}
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" align="center" :index="indexMethod"  sortable :label="$t('BuddleOrderDetail.BuddleOrderDetail7')" min-width="100">
              <template v-slot="scope">
                {{scope.row.sendTime | dateFormatToDay}}
              </template>
            </el-table-column>
            <el-table-column prop="trackingNumberCn" :label="$t('orderList.orderList5')" min-width="110"></el-table-column>
            <el-table-column prop="goodsName" :label="$t('goods.goods2')" min-width="150"></el-table-column>
            <el-table-column prop="taobaoUrl" :label="$t('BuddleOrderDetail.BuddleOrderDetail8')" min-width="200"></el-table-column>
            <el-table-column prop="price" :index="indexMethod"  sortable align="center" :label="$t('excel.excel6')"></el-table-column>
            <el-table-column prop="goodsCount" :index="indexMethod"  sortable align="center" :label="$t('excel.excel7')"></el-table-column>
            <el-table-column prop="colour" :index="indexMethod"  sortable align="center" :label="$t('orderList.orderList26')"></el-table-column>
            <el-table-column prop="goodsSize" :index="indexMethod"  sortable align="center" :label="$t('orderList.orderList27')"></el-table-column>
            <el-table-column prop="customerRemark" :label="$t('goods.goods48')"></el-table-column>
            </el-table>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]"
          :pager-count="5"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        </div>
      </table-con>
  </div>
</template>

<script>
import tableCon from '../../../views/tableContainer'
export default {
  components: { tableCon },
  data() {
    return {
      canReturn:'1',
      pageTitle:this.$t('BuddleOrderDetail.BuddleOrderDetail9'),
      queryInfo:{
        id:'',
        orderId:'',
        trackingNumberCn:'',
        orderStatus:'',
        createTimeStart:'',
        createTimeEnd:'',
        sendTimeStart:'',
        sendTimeEnd:'',
        pageSize:10,
        pageNum:1
      },
       orderDateRangeValue:[],
      shipDateRangeValue:[],
      orderStatusOptions:[],
      recordList:[],
      splitDialogVisible:false,
      orginSplitOrderInfo:{},
      splitOrderInfo:{},
      splitForm:{},
      total:0,
      tkPackageInfo:{
        userId:'',
        userName:'',
        tongkunNo:'',
        throwWeight:'',
        realWeight:'',
        cartonSizeId:'',
        cartonSize:'',
        oppTypeId:'',
        oppType:'',
        oppCount:'',
      },
    }
  },
  methods:{
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderStatusShow(status){
      switch(status){
        case '0':
        return this.$t('orderList.orderList8')
        break;
         case '1':
        return this.$t('orderList.orderList6')
        break;
         case '2':
        return this.$t('orderList.orderList7')
        break;
        case '4':
        return this.$t('orderList.orderList64')
        break;
        case '8':
        return this.$t('orderList.orderList65')
        break;
        case '12':
        return this.$t('orderList.orderList66')
        break;
        case '16':
        return this.$t('orderList.orderList10')
        break;
        case '20':
        return this.$t('orderList.orderList33')
        break;
        case '24':
        return this.$t('orderList.orderList34')
        break;
        case '28':
        return this.$t('orderList.orderList68')
        break;
        case '32':
        return this.$t('orderList.orderList69')
        break;
        case '36':
        return this.$t('orderList.orderList70')
        break;
        case '40':
        return this.$t('orderList.orderList71')
        break;
        case '44':
        return this.$t('orderList.orderList11')
        break;
        case '48':
        return this.$t('orderList.orderList72')
        break;
        case '52':
        return this.$t('orderList.orderList73')
        break;
        case '56':
        return this.$t('status.status4')
        break;
        case '60':
        return this.$t('orderList.orderList74')
        break;
        case '64':
        return this.$t('orderList.orderList75')
        break;
        case '68':
        return this.$t('orderList.orderList76')
        break;
        case '72':
        return this.$t('orderList.orderList77')
        break;
        case '76':
        return this.$t('orderList.orderList78')
        break;
        case '80':
        return this.$t('orderList.orderList79')
        break;
        case '83':
          return this.$t('orderList.orderList111')
          break;
        case '84':
        return this.$t('orderList.orderList81')
        break;
        case '88':
        return this.$t('orderList.orderList82')
        break;
        case '89':
          return this.$t('orderList.orderList109')
          break;

      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange(){
      
    },
    shipDateRange(){
      
    },
    searchList(){    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList(){
      const {data:res} = await this.$http.get('/tongkun/listDetail',{params:this.queryInfo});
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    toOrderDetail(row){
      console.log(row);
      this.$router.push({
       name:'orderDetail',
       query:{
         id:row.id,
         isEdit:'0'
       }
      })
    },
    queryInfoClear(){    //清空
      this.queryInfo = {
        orderId:'',
        id : this.$route.query.id,
        trackingNumberCn:'',
        orderStatus:'',
        createTimeStart:'',
        createTimeEnd:'',
        sendTimeStart:'',
        sendTimeEnd:'',
        pageSize:10,
        pageNum:1
      }
      this.orderDateRangeValue = [];
    },
    async getTkPackageInfo() {
      const {data: res} = await this.$http.get('/tongkun/queryTkPackageInfo/'+this.queryInfo.id);
      this.tkPackageInfo = res.data;
    },
  },
  watch:{
    //监听时间选择器绑定值变化
    orderDateRangeValue(){
      //解决时间选择器清空后 绑定值为null问题
      if(!this.orderDateRangeValue){
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      }
      else{
        if(this.orderDateRangeValue.length>0){
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      } 
    }
  },
  created() {
    this.orderStatusOptions = [
      {
        value: '0',
        label: this.$t('orderList.orderList8')
      },
       {
        value: '1',
        label: this.$t('orderList.orderList6')
      },
       {
        value: '2',
        label: this.$t('orderList.orderList7')
      },
      {
        value: '4',
        label: this.$t('orderList.orderList64')
      },
      {
        value: '8',
        label: this.$t('orderList.orderList65')
      },
      {
        value: '12',
        label: this.$t('orderList.orderList66')
      },
      {
        value: '16',
        label: this.$t('orderList.orderList10')
      },
      {
        value: '20',
        label: this.$t('orderList.orderList33')
      },
      {
        value: '24',
        label: this.$t('orderList.orderList34')
      },
      {
        value: '28',
        label: this.$t('orderList.orderList68')
      },
      {
        value: '32',
        label: this.$t('orderList.orderList69')
      },
      {
        value: '36',
        label: this.$t('orderList.orderList70')
      },
      {
        value: '40',
        label: this.$t('orderList.orderList71')
      },
      {
        value: '44',
        label: this.$t('orderList.orderList11')
      },
      {
        value: '48',
        label: this.$t('orderList.orderList72')
      },
      {
        value: '52',
        label: this.$t('orderList.orderList73')
      },
      {
        value: '56',
        label: this.$t('status.status4')
      },
      {
        value: '60',
        label: this.$t('orderList.orderList74')
      },
      {
        value: '64',
        label: this.$t('orderList.orderList75')
      },
      {
        value: '68',
        label: this.$t('orderList.orderList76')
      },
      {
        value: '72',
        label: this.$t('orderList.orderList77')
      },
      {
        value: '76',
        label: this.$t('orderList.orderList78')
      },
      {
        value: '80',
        label: this.$t('orderList.orderList79')
      },
      {
        value: '84',
        label: this.$t('orderList.orderList81')
      },
      {
        value: '88',
        label: this.$t('orderList.orderList82')
      },
    ];
    this.queryInfo.id = this.$route.query.id;
    this.getrecordList();
    this.getTkPackageInfo();
  },
};
</script>

<style lang="less" scoped>
  .role-page > .search-container{
    height: 60px !important;
  }
  .el-table .el-button--small{
    padding: 4px 10px;
  }
  .query-title1 {
    /* padding-right: 10px; */
    height: 30px;
    line-height: 30px;
    width: 125px;
    padding: 0 10px 0 10px;
    text-align: right;
}
.bill_top{
    width: 100%;
    height: 20px;
    margin: 10px;
    padding-right:15px ;
    padding-top: 15px;
    
}
.bill_top span{
    display: block;
    float: left;
    margin-left: 20px;
    
}
.bill_top i{
    text-decoration:underline;
    color: black;
}
.tk-title{
  color: #999999;
}
</style>